import { actionCreatorFactory } from 'typescript-fsa';
import { DealerModel } from 'da-pcc-frontend-shared-domain';

const createAction = actionCreatorFactory('DEALERS');
const fetchDealers = createAction.async<void, DealerModel[], Error>('FETCH');

export { fetchDealers };
